//ER_DATA_TOO_LONG  // Dato muy largo
//ER_DUP_ENTRY  // Dato duplicado
const errores = {
    ER_DATA_TOO_LONG : "Dato sobre el limite permitido",
    ER_DUP_ENTRY : "Dato duplicado"
}

export default errores;


// WEBPACK FOOTER //
// ./src/middleware/errordb.js